import { render } from "./Ripple.vue?vue&type=template&id=07fdaa8f&scoped=true"
import script from "./Ripple.vue?vue&type=script&lang=js"
export * from "./Ripple.vue?vue&type=script&lang=js"

import "./Ripple.vue?vue&type=style&index=0&id=07fdaa8f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07fdaa8f"

export default script